export const ADD_TO_SERVICE_LIST = "ADD_TO_SERVICE_LIST";
export const REMOVE_FROM_SERVICE_LIST = "REMOVE_FROM_SERVICE_LIST";
export const CLEAR_SERVICE_LIST = "CLEAR_SERVICE_LIST";

// Ajouter ou remplacer un service
export const addToServiceList = (item) => {
  return {
    type: ADD_TO_SERVICE_LIST,
    payload: item,
  };
};

// Retirer un service par code
export const removeFromServiceList = (code) => {
  return {
    type: REMOVE_FROM_SERVICE_LIST,
    payload: code,
  };
};

// Réinitialiser la liste
export const clearServiceList = () => {
  return {
    type: CLEAR_SERVICE_LIST,
  };
};
